import script from "./StatsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsHeader.vue?vue&type=script&setup=true&lang=js"

import "./StatsHeader.vue?vue&type=style&index=0&id=24f6daaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f6daaf"]])

export default __exports__